

















































































































































































































































































































































































































import PropertyUpdate from "@/components/property/propertyUpdateComponent.vue";
import Company from "@/model/company";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import _ from "lodash";
const auth = namespace("Auth");
@Component({
  name: "PropertyEdit",
})
export default class PropertyEdit extends PropertyUpdate {
  @auth.Getter
  getCurrentyCompany!: Company;

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  async mounted() {
    this.propertyObject.company_id = this.getCurrentyCompany.id;
    this.propertyObjectInit = _.cloneDeep(this.propertyObject)
  }
  
}
